export const LastLocationKey = 'storedLastLocation';
